import { BotMode, ChatRole, LanguagesEnum } from 'types/index'

type UserProps = {
  userId: string | null
  userToken: string | null
  chatRole: ChatRole | null
}

/**
 * Get user token from URL query params
 */
export const getUserToken = (): string => {
  const searchParams = new URLSearchParams(window.location?.search)
  return searchParams.get('token') ?? ''
}

/**
 * Get user id from URL query params
 */
export const getUserId = (): string => {
  const searchParams = new URLSearchParams(window.location?.search)
  return searchParams.get('userId') ?? ''
}

/**
 * Get chat role from URL query params
 */
export const getChatRole = (): ChatRole | null => {
  const searchParams = new URLSearchParams(window.location?.search)
  return searchParams.get('chatRole') as ChatRole
}

export const getBotMode = (): BotMode => {
  const searchParams = new URLSearchParams(window.location?.search)
  return searchParams.get('mode') as BotMode
}

export const getAreaIdSearchParams = (): string | undefined => {
  const searchParams = new URLSearchParams(window.location?.search)
  const areaId = searchParams.get('areaId')
  return areaId ? String(areaId) : undefined
}

/**
 * Get language from URL query params
 */
export const getLang = (): LanguagesEnum => {
  const lang = new URLSearchParams(window.location?.search).get('lang') ?? ''

  return (lang ?? 'it') as LanguagesEnum
}

/**
 * Get user props from URL query params
 */
export const getUserProps = (): UserProps => {
  const userId = getUserId()
  const userToken = getUserToken()
  const chatRole = getChatRole()

  return {
    userId,
    userToken,
    chatRole: chatRole as UserProps['chatRole'],
  }
}
